// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"OX-z","subtitle":"PX-z","wrapper":"QX-z","leftArrow":"RX-z","rightArrow":"SX-z"};